import { ControlType, Property, PropertyType } from "../../../base/types";

import { Carousel } from "react-bootstrap";
import { IControlAttributes } from "../../../base/models";
import { Registry } from "../../../base/register";
import { toAbsoluteUrl } from "../../../../helpers";
import { useGetProperties } from "../../../base/hooks";

export const CarouselComponent = (props: IControlAttributes) => {
  const { control } = props;
  const { properties } = useGetProperties({ bindings: control.bindings });
  const tooltip: string | undefined = properties[Property.Tooltip];
  const altText: string | undefined = properties[Property.AltText];

  const imageUrlsString: string | undefined = properties[Property.ImageUrls];
  const imageUrls: string[] = imageUrlsString ? imageUrlsString.split(',').map(url => url.trim()) : [];

  return (
    <>
      <Carousel slide={true} prevIcon={false} nextIcon={false}>
        {imageUrls.map((url, index) => (
          <Carousel.Item key={index}>
            <img
              alt={altText}
              className="w-100"
              style={{ objectFit: "cover", objectPosition: "top" }}
              src={toAbsoluteUrl(url)}
              title={tooltip}
            />
          </Carousel.Item>
        ))}
      </Carousel>
    </>
  );
};

Registry.addControl({
  id: "5b66086f-d5ce-42bb-94a0-40fee9a1edb1",
  name: "Carousel",
  type: ControlType.Carousel,
  properties: [
    { id: Property.AltText, name: 'Alternate text', type: PropertyType.String },
    { id: Property.ImageUrls, name: 'Url', type: PropertyType.String },
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String }
  ],
  component: CarouselComponent,
})
